import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SpecialToolBusinessService } from '../../business-services/special-tool.service';


@Injectable({ providedIn: 'root' })
export class EdiSpecialToolGuard  {

  constructor(
    private specialToolService: SpecialToolBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.specialToolService.SpecialToolId) {
      return true;
    }
    return this.router.createUrlTree(['/specialTool']);
  }
}
